import { hasCode, hasSideData } from '@/utils/tool';
//某个页面需要控制在这添加
const coderArr = [
  { code: 'CONSOLE_MARKET_BILL_VIEW', pageName: 'billingManagement' },
  { code: 'CONSOLE_MARKET_ORDER_VIEW', pageName: 'orderManagement' },
  { code: 'CONSOLE_MARKET_ENTER_VIEW', pageName: 'appList' },
  { code: 'CONSOLE_MARKET_ENTER_VIEW', pageName: 'payFirst' },
  { code: 'CONSOLE_MARKET_TAX_VIEW', pageName: 'taxInfo' },
];
export default function showPage(name: any) {
  let to403 = false;
  //当没有拿到权限时直接放过
  if (!hasSideData()) {
    return to403;
  }
  coderArr.forEach(obj => {
    if (obj.pageName === name && !hasCode(obj.code)) {
      to403 = true;
    }
  });

  return to403;
}
